import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Detects "embedded" mode from URL query (?embedded=true).
 * Used by /sign-in to render a chrome-less popup variant for the broker iframe flow.
 */
export const useEmbeddedMode = () => {
    const [searchParams] = useSearchParams();

    const isEmbedded = useMemo(
        () => searchParams.get('embedded') === 'true',
        [searchParams],
    );

    return { isEmbedded };
};
